var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInprogReq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 54,
    height: 54,
    rx: 27,
    fill: "#F6F7FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_8824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4548 19.0441L33.6873 20.8116C32.2559 19.3801 30.3725 18.4892 28.3579 18.2907C26.3433 18.0922 24.3222 18.5983 22.6389 19.7229C20.9557 20.8474 19.7144 22.5209 19.1267 24.458C18.5389 26.3952 18.641 28.4762 19.4156 30.3465C20.1902 32.2168 21.5893 33.7607 23.3745 34.7151C25.1598 35.6694 27.2207 35.9753 29.2062 35.5805C31.1917 35.1857 32.9789 34.1147 34.2632 32.5499C35.5476 30.9852 36.2496 29.0235 36.2498 26.9991H38.7498C38.7497 29.6019 37.8472 32.1241 36.1961 34.136C34.5449 36.148 32.2472 37.5251 29.6944 38.0329C27.1417 38.5406 24.4919 38.1476 22.1965 36.9206C19.9011 35.6937 18.1021 33.7088 17.1061 31.3042C16.1101 28.8995 15.9786 26.2239 16.7342 23.7333C17.4898 21.2426 19.0855 19.091 21.2497 17.645C23.4138 16.199 26.0123 15.5481 28.6025 15.8032C31.1927 16.0584 33.6144 17.2037 35.4548 19.0441Z",
    fill: "#4361EE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_8824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(12.5 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInprogReq);
export default __webpack_public_path__ + "static/media/inprog-req.a449f6ec9fd70f222fefad85a625a5dd.svg";
export { ForwardRef as ReactComponent };